
const HrDivider = ({text}) => {
  return (
    <div className='hr-text'>
        <div></div>
        <p>{text}</p>
        <div></div>
    </div>
  )
}

export default HrDivider